import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';
import logo from "../images/logo.png";

export default function Footer() {
  return (
    <footer className=" text-black py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1">
            <img src={logo} alt="Sarayu Logo" className="h-10 w-auto mb-4" />
            <p className="text-black-400 text-sm">
              Your AI co-pilot. It thinks ahead, so you can be present.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/features" className="text-black-400 hover:text-black transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/highlights" className="text-black-400 hover:text-black transition-colors">
                  Highlights
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-black-400 hover:text-black transition-colors">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-black-400 hover:text-black transition-colors">
                  Our Vision
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-black-400 hover:text-black transition-colors">
                  Get in Touch
                </Link>
              </li>
              <li>
                <a href="#" className="text-black-400 hover:text-black transition-colors">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a href="#" className="text-black-400 hover:text-black transition-colors">
                <Mail size={20} />
              </a>
              <a href="#" className="text-black-400 hover:text-black transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-black-400 hover:text-black transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-black-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-black-400 text-sm">
              © 2025 Sarayu. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-black-400 hover:text-black text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-black-400 hover:text-black text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
